import axios from "axios";
import store  from "./store";
const getAuthToken = () => {
  const state = store.getState();
  return state.server?.API_BASE_URL 
};
const auth = window.localStorage.token ? "Bearer " + window.localStorage.token : null;

export default axios.create({
  baseURL: getAuthToken(),
  headers: {
    withCredentials: true,
    Authorization: auth,
    // "Access-Control-Allow-Origin": "*",
    // "Content-Type": "application/json",
    // Accept: "application/json",
    // "X-Requested-With": "XMLHttpRequest",
    // "Access-Control-Allow-Headers": "*",
  },
});
